import React, {FC} from 'react'

type Props = {
  gender?: string
}

const UserGenderCell: FC<Props> = ({gender}) => {
  return <div>{gender}</div>
}

export default UserGenderCell
